<template>
  <div>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <material-card
      :title="$t('views.invoices_view.invoices')"
      color="rgb(0, 168, 215)"
      icon="list"
    >
      <v-card-text>
        <v-autocomplete
          :label="$t('globals.plan')"
          v-model="plan"
          :items="plans.filter((o) => o.PlanType === 'HW')"
          :item-text="planDescription"
          item-value="Id"
          hide-details
          clearable
          return-object
          :rules="[$rules.required]"
          class="required"
        ></v-autocomplete>
      </v-card-text>
      <invoices-table
        v-if="plan !== null && plan !== undefined"
        :planIdentityId="plan.Id"
        :actions="true"
      ></invoices-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { translate2 } from "@/trans2";
import InvoicesTable from "@/components/Invoices/InvoicesTable";

export default {
  name: "users-table",
  components: {
    ErrorHandler,
    InvoicesTable,
  },
  data() {
    return {
      error: null,
      plan: null,
      loading: false,
      plans: [],
    };
  },
  mounted() {
    this.loadUserPlans();
  },
  methods: {
    ...mapActions("plansMembers", ["getUserPlans"]),
    ...mapActions("auth", ["silentRefresh", "login"]),
    planDescription(plan) {
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
    async loadUserPlans() {
      this.loading = true;
      try {
        const usr = await this.silentRefresh();
        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.plans = plans.map((o) => {
            o.Name = o.Current.Name;
            o.Description = o.Current.Description;
            o.Translations = o.Current.Translations;
            return o;
          });
        }
      } catch (error) {
        //console.log("selectPlan: silent refresh error: ", error);
        this.login();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
